<template>
  <basic-setting
    :style="{padding: '12px 16px'}"
    v-if="typeof config === 'string' || (config.type=== 'basic' && enable(config))"
    :config="config"
  />
  <sub-collapse-setting v-else-if="config.type === 'subCollapse'  && enable(config)" :settings="config.settings" :title="config.title" :tips="config.tips" />
  <block-setting v-else-if="config.type === 'block'  && enable(config)" :settings="config.settings" />
  <status-setting v-else-if="config.type === 'status' && enable(config)" :statusSettings="config.statusSettings" :isRoot="true"/>
  <collapse-setting v-else-if="config.type === 'collapse'  && enable(config)" :settings="config.settings" :title="config.title" :initStatus="config.initStatus"/>
  <collection-setting v-else-if="config.type === 'collection'  && enable(config)" :settings="config.settings" :title="config.title"/>
</template>
<script>
import blockSetting from "./block-setting.vue"; 
import basicSetting from "./basic-setting.vue"
import subCollapseSetting from "./sub-collapse-setting.vue";
import collapseSetting from "./collapse-setting.vue";
import statusSetting from "./status-setting.vue";
import collectionSetting from "./collection-setting.vue";
export default {
  name: 'config-item',
  inject: ['configData', 'configs', 'mergedConfigData'],
  components: {
    collectionSetting,
    basicSetting,
    blockSetting,
    subCollapseSetting,
    collapseSetting,
    statusSetting
  },
  props: {
    config: undefined
  },
  computed: {
    enable() {
      return (config) => {
        if (config?.enable) {
          return config.enable(this.mergedBasicConfigData)
        }
        return true
      }
    },
    basicConfigData() {
      return this.configData()
    },
    mergedBasicConfigData() {
      return this.mergedConfigData()
    }
  }
}
</script>